// import moment from 'moment';
import { pick } from 'lodash';

export function constructExchangeEmail(transactions) {
  const filteredTransactionsPayload = transactions.map((transaction) => {
    // transaction.tradeDate = moment(transaction.tradeDate).valueOf();
    return pick(transaction, [
      '@Type',
      'bankAgreementKey',
      'tradeDate',
      'confirmationNumber',
      'transactionID',
      'type',
      'transactionRecords',
    ]);
  });

  filteredTransactionsPayload.forEach((ele) => {
    ele.transactionRecords = ele.transactionRecords.map((transactionRecord) => {
      /* if(transactionRecord.subType &&
        transactionRecord.subType.enumerationID &&
        transactionRecord.subType.enumerationID === 1032) {
        if (transactionRecord.targetPositionKey && transactionRecord.targetPositionKey.agreementKey) {
          const {
            targetPositionKey: {
              agreementKey: {
                //trpCode
              }
            }
          } = transactionRecord;
        }
      } */
      transactionRecord['@Type'] = 'TransactionRecord';
      transactionRecord['EXCHANGE'] = true;
      return transactionRecord;
    });
  });
  return filteredTransactionsPayload;
}
